import { render, staticRenderFns } from "./liveCommerce.vue?vue&type=template&id=23c2fa23&scoped=true"
import script from "./liveCommerce.vue?vue&type=script&lang=js"
export * from "./liveCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2fa23",
  null
  
)

export default component.exports